import { ResourceOptions } from 'react-admin';
import { FaRegUser } from 'react-icons/fa';
import { Resources } from '../resource';
import ListComponent from './List';

export const list = ListComponent;

export const name = Resources.tradingRetention;
export const icon = FaRegUser;
export const options: ResourceOptions = {
  label: 'resource.tradingRetention',
};
